module.exports = __webpack_public_path__ + "media/application/images/icons/help-348ad0750f28cd53560ec8c3baaa3806.png";